export default __webpack_public_path__ + "static/imgExcess-7d4c728c1dde0715928949ecc46991e0.webp";